import type { GPUInstanceType } from "types/InstanceTypes";
import { getPrimaryInstanceCloudCredId } from "utils/cloudCreds";

export const getInstanceSelectionKey = (
  instance: GPUInstanceType | null | undefined,
) =>
  instance
    ? `${instance.type}:${
        getPrimaryInstanceCloudCredId(instance) ??
        instance.cloud ??
        instance.provider ??
        ""
      }`
    : "";

interface GetProviderSwitchInstancesOptions {
  allowProviderSwitching: boolean;
  allInstances: GPUInstanceType[];
  relevantInstances: GPUInstanceType[];
  intendedInstanceTypeObject: GPUInstanceType | null;
  currentInstanceTypeObject: GPUInstanceType | null;
}

export const getProviderSwitchInstances = ({
  allowProviderSwitching,
  allInstances,
  relevantInstances,
  intendedInstanceTypeObject,
  currentInstanceTypeObject,
}: GetProviderSwitchInstancesOptions): GPUInstanceType[] => {
  if (!allowProviderSwitching) return [];

  const intendedInstanceKey = getInstanceSelectionKey(
    intendedInstanceTypeObject,
  );
  const originalAvailableInstance = allInstances.find(
    (instance) => getInstanceSelectionKey(instance) === intendedInstanceKey,
  );
  const originalInstance =
    originalAvailableInstance || intendedInstanceTypeObject;
  const candidates = originalInstance
    ? [originalInstance, ...relevantInstances]
    : relevantInstances;
  const availableInstances = new Set(allInstances.map(getInstanceSelectionKey));
  const currentInstanceKey = getInstanceSelectionKey(currentInstanceTypeObject);
  const seenInstances = new Set<string>();

  return candidates.filter((instance) => {
    const instanceKey = getInstanceSelectionKey(instance);
    const canSwitchToInstance =
      instanceKey !== currentInstanceKey &&
      availableInstances.has(instanceKey) &&
      !seenInstances.has(instanceKey);
    seenInstances.add(instanceKey);
    return canSwitchToInstance;
  });
};
